import { Component, inject, Input } from '@angular/core';

import { IconProp } from '@fortawesome/fontawesome-svg-core';

import { AlertContextType, ContextType, ExternalUrl, ToastConfig } from '@bn/primitives';
import { BnToastrService } from '@bn/shared/toastr';

import { BnToastComponent } from '../toastr/components/bn-toast/bn-toast.component';

@Component({
  selector: 'bn-web-ui-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  imports: [BnToastComponent],
})
export class AlertComponent {
  private readonly toastrService = inject(BnToastrService);

  @Input()
  public set alertType(severity: AlertContextType) {
    this.severity = severity;
    this.headerIcon = this.toastrService.config.iconClasses[severity];
  }

  @Input()
  public heading?: string;

  @Input()
  public externalLink?: ExternalUrl;

  @Input()
  public headerIcon!: IconProp;

  @Input()
  public headerIconStyle?: ContextType;

  @Input()
  public customClass?: string;

  @Input()
  public set showClose(showClose: boolean) {
    this.config.showClose = showClose ?? false;
  }

  @Input()
  public set showIcon(showIcon: boolean) {
    this.config.showIcon = showIcon;
  }

  public config!: ToastConfig;
  public isVisible = true;
  public severity!: ContextType;

  public constructor() {
    // NOTE: some defaults for alert
    this.config = {
      ...this.toastrService.config,
      autohide: false,
      showIcon: true,
      showClose: false,
    };
  }

  public hideAlert(): void {
    this.isVisible = !this.isVisible;
  }
}
